import { ReactNode } from "react";
import { Row, Typography } from "antd";
import styles from "Components/Report/report.module.scss";
// import CompanyMainLogo from "image/CompanyMainLogo.png";
import Print_Osmart_Logo from "image/Print_Osmart_Logo.jpg";
import ReportHeader from "image/ReportHeader.jpg";
import QR from "image/QR.png";
import { useAppSelector } from "store/hook";
import { DateToFormattedString } from "../../Periodic/Reports";
import { timeOptions, unitOptions, accountOptions, deviceOptions } from "../Filter";

const { Text } = Typography;

const CoverPage = () => {
  const { filterForm } = useAppSelector((state) => state.report);

  const duration = () => {
    if (filterForm.time) {
      return timeOptions.find((item) => item.value === filterForm.unit)?.label;
      // return filterForm.time;
    } else if (filterForm.start_utc && filterForm.end_utc) {
      return `${DateToFormattedString(filterForm.start_utc * 1000)} - ${DateToFormattedString(
        filterForm.end_utc * 1000
      )}`;
    }
  };
  const getUnit = () => {
    switch (filterForm.unit) {
      case 3600:
        return "Hour";
      case 86400:
        return "Day";
      case 604800:
        return "Week";
      case 2592000:
        return "Month";
    }
  };
  return (
    <div
      style={{ width: "100%", padding: "5px 50px 5px 50px" }}
      className={[styles.breakAfter, styles.printOny].join(" ")}
    >
      <div style={{ display: "flex", alignItems: "center", height: "800px", width: "100%" }}>
        <div style={{ display: "flex", alignItems: "start", marginTop: "300px", width: "100%" }}>
          <img src={Print_Osmart_Logo} className={styles.logoIMG} />

          <div style={{ width: "100%", marginLeft: "120px" }}>
            <p className={styles.font24}>On-Demand Usage Report</p>
            <br />
            <p className={styles.font14}>
              <strong>Duration:</strong> {duration()}
            </p>
            <br />
            <p className={styles.font14}>
              <strong>Unit:</strong> {getUnit()}
            </p>
            <br />
            <p className={styles.font14}>
              <strong>Account-Parameter:</strong>
              {filterForm.account_parameter
                ?.map((param) => accountOptions.find((o) => o.value === param)?.label)
                .join(", ")}
            </p>
            <br />
            <p className={styles.font14}>
              <strong>Account-Devices:</strong> {filterForm.account_device?.join(", ")}
            </p>
            <br />
            <p className={styles.font14}>
              <strong>Device-Parameter:</strong>
              {filterForm.device_parameter
                ?.map((param) => deviceOptions.find((o) => o.value === param)?.label)
                .join(", ")}
            </p>
            <br />
            <p className={styles.font14}>
              <strong>Device-Devices:</strong> {filterForm.device_device?.join(", ")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoverPage;

export const PrintHeaderFooter = ({ children }: { children: ReactNode }) => {
  return (
    // <div className={styles.printOny}>
    <>
      <img
        style={{ position: "fixed", top: 3, left: 10, width: "60mm", height: "auto" }}
        alt=""
        src={ReportHeader}
        className={styles.printOny}
      />

      {children}

      <span
        style={{ position: "fixed", bottom: 3, left: 10, fontSize: "14pt", fontFamily: "Calibri" }}
        className={styles.printOny}
      >
        {window?.ReportRightsText}
      </span>
    </>
  );
};

export const EndPage = () => {
  return (
    <div
      className={styles.printOny}
      // style={{ width: "100%", padding: "5px 50px", display: "flex", flexDirection: "column", alignItems: "flex-start" }}
    >
      <div className={styles.endPage}>
        <div style={{ display: "flex", alignItems: "center", height: "800px", width: "100%" }}>
          <img src={Print_Osmart_Logo} className={styles.logoIMG} />
          <p style={{ fontSize: "30pt", fontWeight: "bold", flex: 1, textAlign: "center" }}>End of Report</p>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img src={QR} style={{ width: "30mm", height: "30mm" }} />
          <p style={{ fontSize: "14pt", fontFamily: "Calibri", marginTop: "1pt" }}>{window?.CompanyWebsite}</p>
        </div>
      </div>
    </div>
  );
};
